import React, { forwardRef } from 'react';
const EditOff = forwardRef((props, ref) => (React.createElement("svg", { viewBox: "0 0 24 24", height: "1em", role: "img", ref: ref, ...props },
    React.createElement("g", { fill: "currentColor" },
        React.createElement("path", { d: "M5.362 22.425H1.5v-3.862l6.975-6.975-1.05-1.088L0 17.925v6h6l7.425-7.425-1.087-1.05zM14.55 5.513l3.862 3.862-2.962 2.962 1.05 1.05L23.925 6l-6-6L10.5 7.425l1.05 1.05zm3.375-3.375L21.787 6l-2.324 2.325-3.863-3.9zM1.06.064 0 1.125l22.937 22.937L23.997 23z" })))));
EditOff.displayName = 'EditOff';
// @ts-ignore;
const iconData = {
    glyph: EditOff,
    group: 'basic',
};
export default iconData;
